import type TrackVisitRequest from '~/models/Api/TrackVisitRequest'

export type PendingVisitTracking = Omit<TrackVisitRequest, 'uid'>

export default () => {
    return useCookie<PendingVisitTracking | null>('pendingVisitTracking', {
        maxAge: 2592000, // 30 days - same window as the uid cookie, so the first touch survives until a basket/login gives it an identity
        secure: true,
    })
}
